import {createMuiTheme} from "@material-ui/core"

const theme = createMuiTheme({
    palette: {
        primary: {
            main: process.env.REACT_APP_PRIMARYCOLOR || '#37843e',
            contrastText: '#fff'
        },
        secondary: {
            main: process.env.REACT_APP_SECONDARYCOLOR || '#aacc4a',
        }
    },
    spacing: 8
});

theme.props = {
    MuiAppBar: {
        elevation: '0'
    },
    MuiBottomNavigation:{
        showLabels: true,
    },
    MuiInputLabel: {
        shrink: true
    },
    MuiGrid:{
        spacing: 1
    }
}

theme.overrides = {
    MuiBottomNavigation: {
        root:{
            position:'fixed',
            bottom: '0',
            width:'100%',
            borderTop: `1px solid ${theme.palette.primary.main}`
        },
    },
    MuiFab:{
        root:{
            top: 'auto',
            right: 10,
            bottom: 75,
            left: 'auto',
            position: 'fixed',
        }
    },
    MuiSwitch:{
        switchbase: {
            color: process.env.REACT_APP_SECONDARYCOLOR || '#aacc4a'
        },
        colorSecondary: {
            "&$checked": {
                color: process.env.REACT_APP_PRIMARYCOLOR || '#aacc4a'
            }
        }
    }
}

export default theme;
